/** Должно совпадать с inline-скриптами в `partials/header-desktop-dark-*.njk` */
export const HEADER_DESKTOP_SCROLL_DARK_CONFIG = {
  storageKey: 'stcHeaderDesktopDark',
  htmlClass: 'stc-header-desktop-dark',
  thresholdPx: 48,
  desktopMediaQuery: '(min-width: 992px)',
} as const;
